// frontend/src/visitor_ai/components/QuickActionButton.jsx
import React from "react";

const QuickActionButton = ({ label = "Action", actionSchema = {}, onClick = () => {} }) => {
  return (
    <button className="visitor-ai-action-button" onClick={() => onClick(actionSchema)}>
      {label}
    </button>
  );
};

export default QuickActionButton;
